import { useQueryWithErrorBoundary, useSupabaseTypedClient } from 'hooks/reactQuery';

import { TanstackQueryName } from 'types/frontend';

import { UserCV } from '../types';

export const useGetCVQuery = (cvId: string | undefined) => {
  const supabase = useSupabaseTypedClient();

  const { data, isFetching, refetch } = useQueryWithErrorBoundary({
    queryKey: [TanstackQueryName.GetCV, cvId],
    queryFn: async () => {
      if (!cvId) return null;

      const { data, error } = await supabase
        .from('user_cv')
        .select('*')
        .eq('id', cvId)
        .single();

      if (error) throw error;

      return data as unknown as UserCV;
    },
    enabled: Boolean(cvId),
  });

  return {
    cv: data || null,
    isFetching,
    refetch,
  };
};
